module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"New Bill","input-1":"Description","input-2":"Total","input-3":"Status","input-4":"Method","input-5":"Type","create":"Create bill"},"pt-BR":{"title":"Novo Lançamento","input-1":"Descrição","input-2":"Total","input-3":"Status","input-4":"Método","input-5":"Tipo","create":"Criar lançamento"}}')
  delete Component.options._Ctor
}
